import * as Yup from "yup";
import httpClient from "../config/HttpClient";
import { MANAGERS_DETAILS, MANAGERS_URL } from "../routes";
import { translations } from "../../../translations/common";

export interface ManagerDetailsData {
  email: string;
  firstName: string;
  lastName: string;
  username: string;
}

export interface ManagerData extends ManagerDetailsData {
  id?: string;
  auth0Email: string;
  userType: string;
  active: boolean;
}

export const defaultManagerData: Readonly<ManagerData> = {
  id: undefined,
  email: "",
  auth0Email: "",
  userType: "",
  firstName: "",
  lastName: "",
  username: "",
  active: true
};

export const managerSchema = Yup.object().shape({
  email: Yup.string()
    .email(translations.managers.form.validation.emailInvalid)
    .required(translations.managers.form.validation.emailRequired),
  auth0Email: Yup.string()
  .email(translations.managers.form.validation.emailInvalid)
  .required(translations.managers.form.validation.emailRequired),
  userType: Yup.string().required(translations.managers.form.validation.userTypeRequired),
  firstName: Yup.string().required(translations.managers.form.validation.firstNameRequired),
  lastName: Yup.string().required(translations.managers.form.validation.lastNameRequired),
  username: Yup.string().required(translations.managers.form.validation.usernameRequired),
  active: Yup.boolean().required(translations.managers.form.validation.activeRequired)
});

export class ManagersModel {
  static async updateDetails(model: ManagerDetailsData): Promise<Partial<ManagerData>> {
    const response = await httpClient.put<Partial<ManagerData>>(MANAGERS_DETAILS, model);
    return response.data;
  }

  static async updateOrCreate(model: ManagerData): Promise<ManagerData> {
    const url = model.id ? `${MANAGERS_URL}/${model.id}` : MANAGERS_URL;
    const method = model.id ? httpClient.put : httpClient.post;
    const response = await method<ManagerData>(url, model);
    return response.data;
  }

  static async getCurrentManager(): Promise<ManagerData> {
    const response = await httpClient.get<ManagerData>(`${MANAGERS_URL}/me`);
    return response.data;
  }

  static async delete(id: string): Promise<void> {
    await httpClient.delete(`${MANAGERS_URL}/${id}`);
  }

  static async resetPassword(id: string): Promise<void> {
    await httpClient.post(`${MANAGERS_URL}/remember/${id}`);
  }

  static async listAll(): Promise<ManagerData[]> {
    const response = await httpClient.get<ManagerData[]>(MANAGERS_URL);
    return response.data;
  }
}

export default ManagersModel;
